import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { fetchCartItemAction } from '@app/react/action/fetchCartItem';
import { pushCartEditAction } from '@app/react/action/pushCartEditAction';
import type { AsyncGeneralState } from '@app/react/const/type';

export interface EditCartUIReducer {
    fetchCartItemState: AsyncGeneralState;
    pushCartEditState: AsyncGeneralState;
}

const initState: EditCartUIReducer = {
    fetchCartItemState: 'init',
    pushCartEditState: 'init',
};

export const editCartUIReducer = reducerWithInitialState(initState)
    .case(fetchCartItemAction.started, (state) => ({
        ...state,
        fetchCartItemState: 'request',
    }))
    .case(fetchCartItemAction.failed, (state) => ({
        ...state,
        fetchCartItemState: 'error',
    }))
    .case(fetchCartItemAction.done, (state) => ({
        ...state,
        fetchCartItemState: 'done',
    }))
    .case(pushCartEditAction.started, (state) => ({
        ...state,
        pushCartEditState: 'request',
    }))
    .case(pushCartEditAction.failed, (state) => ({
        ...state,
        pushCartEditState: 'error',
    }))
    .case(pushCartEditAction.done, (state) => ({
        ...state,
        pushCartEditState: 'done',
    }));
